import Sidebar from "./Sidebar";

const Layout = ({children}) => {
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-2 text-white bg-dark vh-100 py-3" style={{overflow: 'auto'}}>
                    <Sidebar />
                </div>
                <div className="col-md-10 py-2">
                    {children}
                </div>
            </div>
        </div>
    )
}

export default Layout;
